<template>
  <v-app id="enroll">
    <v-content class="white">
      <div id="custom-wrapper">
        <v-container>
          <v-row align="center" justify="center" class="pa-5 mb-0 pb-0">
            <v-col cols="12">
              <v-card class="pattern-bg pa-5 mx-3 text-dark" v-bind:class="{ 'primary--text': 'green' }">
                {{'U heeft betaald 🎉'}}
              </v-card>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="mb-10">
            <img src="@/assets/money.gif" style="height:61vh"/>
          </v-row>
        </v-container>
        <v-container style="text-align: center; font-size: 18px;">
          Bedankt, uw betaling is binnen gekomen!
        </v-container>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  data: () => ({
    payment: "",
  }),
  computed: {
    ...mapState({
    })
  },
  mounted() {
    this.payment = this.$route.params.payment;
    if(this.payment===undefined){
      this.redirectCountry();
    }else{
      this._getPaymentById(this.payment.id)
          .then((data) => {
            if(!data){
              // betaling gefaald, pagina gerefresht, onzin gedaan, weet ik veel
            }
          });
    }
  },
  methods: {
    ...mapActions('payment', [
      '_getPaymentById'
    ])
  }
};
</script>
<style src="../Status/Status.scss" scoped lang="scss"></style>

